export const API_URL = process.env.REACT_APP_API_URL;
export const VISAKA_SERVICES_API_URL = process.env.REACT_APP_VISAKA_SERVICES_API_URL;
export const CDN_URL = process.env.REACT_APP_CDN_URL;
export const CAMPAIGN_ID_ENQUIRY = process.env.REACT_APP_CAMPAIGN_ID_ENQUIRY;
export const CAMPAIGN_ID_CONTACT = process.env.REACT_APP_CAMPAIGN_ID_CONTACT;
export const CAMPAIGN_ID_VNEXTLANDING = process.env.REACT_APP_CAMPAIGN_ID_VNEXTLANDING;
